import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "position"
const PositionIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 10.5C12.83 10.5 13.5 11.172 13.5 12S12.83 13.5 12 13.5C11.172 13.5 10.5 12.828 10.5 12S11.172 10.5 12 10.5" />
          <path
            fillRule="evenodd"
            d="M12 1.5C12.415 1.5 12.75 1.836 12.75 2.25V4.537C16.292 4.89 19.11 7.705 19.462 11.247H21.754C22.168 11.246 22.504 11.581 22.504 11.996 22.504 12.41 22.168 12.746 21.754 12.746H19.463C19.113 16.29 16.295 19.11 12.75 19.461V21.75C12.75 22.164 12.415 22.5 12 22.5 11.586 22.5 11.25 22.164 11.25 21.75V19.462C7.706 19.11 4.888 16.292 4.538 12.746H2.254C1.84 12.746 1.504 12.411 1.504 11.996 1.504 11.582 1.84 11.246 2.254 11.246H4.538C4.892 7.705 7.708 4.89 11.25 4.537V2.25C11.25 1.836 11.586 1.5 12 1.5M12 6C8.704 6 6.03 8.658 6.001 11.947Q6.003 11.972 6.004 11.997L6 12.046C6.026 15.339 8.702 18 12.001 18 15.313 18 18 15.314 18 12S15.313 6 12 6"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PositionIcon
